import i18next from 'i18next';
import { SET_STEP, RESET_STORE, RESET_FROM, PREV_STEP, NEXT_STEP, UPDATE_SURVEY, CHECK_LAST_STEP } from '../actions';
import { STEPS, ROUTE_TYPES, VEHICLES_TYPES, VEHICLES_AMOUNT, OPTIONS } from 'constants/survey'

const initialSurvey = {
  vehicleType: '', // Step1
  vehiclesAmount: '', // Step 2
  routeType: '', // Step 3
  region: '', // Step 4
  bill: '', // Step 5
  credit: '' // Step 6
}

const initialState = {
  step: 1,
  maxSteps: 6,
  isLastStep: false,
  survey: { ...initialSurvey }
};

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_STORE :
      return {
        ...initialState
      };
    case RESET_FROM :
      /*
      Given an object as param, it keeps values of the previous props in survey
      and resets the next props with initialSurvey
      */
      const fromKey = Object.keys(action.payload)[0];
      let prevProps = {};
      let found = false;

      Object.keys(state.survey).forEach((key) => {
        if (found) return false;
        
        if (key !== fromKey) {
          prevProps[key] = state.survey[key];
        } else {
          found = true;
        }  
      });
      return {
        ...state,
        ...{
          survey: { ...initialSurvey, ...prevProps, ...action.payload }
        }
      };
    case SET_STEP:
      return {
        ...state,
        ...{
          step: action.payload
        }
      };
    case PREV_STEP:
      return {
        ...state,
        ...{
          step: getPrevStep(state),
        },
      };
    case NEXT_STEP:
      return {
        ...state,
        ...{
          step: getNextStep(state),
        },
      };
    case UPDATE_SURVEY:
      return {
        ...state,
        ...{
          survey: action.payload,
        },
      };
    case CHECK_LAST_STEP:
      return {
        ...state,
        isLastStep: isLastStep(state) 
      };
    default:
      return state
  }
}

/**
 * Returns next step number, skipping steps if needed, based on state
 * @param {object} state 
 * @returns {boolean}
 */
function getNextStep(state = initialState) {
  let nextStep = state.step; 

  if (state.step === state.maxSteps) {
    return state.step;
  }
  
  for (let i = state.step; i < state.maxSteps; i++) {
    let next = i + 1;
    let skipNextStep = skipStep(next, state);

    if(!skipNextStep) {
      nextStep = next;
      break;
    }
  }

  return nextStep;
}

/**
 * Returns previous step number, skipping steps if needed, based on state
 * @param {object} state 
 * @returns {boolean}
 */
function getPrevStep(state = initialState) {
  let prevStep = state.step; 

  if (state.step === 1) {
    return state.step;
  }
  
  for (let i = state.step; i > 0; i--) {
    let prev = i - 1;
    let skipPrevStep = skipStep(prev, state);

    if(!skipPrevStep) {
      prevStep = prev;
      break;
    }
  }

  return prevStep;
}

/**
 * Returns true if a step must be skipped
 * @param {number} destinationStep 
 * @param {object} state 
 * @returns {boolean}
 */
function skipStep(destinationStep, state = initialState) {
  let routesSelected = state.survey.routeType.split(',');

  switch(destinationStep) {
    case STEPS.ROUTE_TYPE:
      // In case of taxi, step route_type is skipped  
      if (state.survey.vehicleType === i18next.t(VEHICLES_TYPES.TAXI)) {
        return true;
      }
      break;
    case STEPS.REGION:
      // In case route_type its international or national, step region is skipped
      if (routesSelected.indexOf(i18next.t(ROUTE_TYPES.INTERNATIONAL)) !== -1 || routesSelected.indexOf(i18next.t(ROUTE_TYPES.NATIONAL)) !== -1) {
        return true;
      }
      break;
    case STEPS.BILL:
      // In case vehicle its not taxi, step bill is skipped
      if (state.survey.vehicleType !== i18next.t(VEHICLES_TYPES.TAXI)) {
        return true;
      }
      break;
    case STEPS.CREDIT:
      switch(state.survey.vehicleType) {
        case i18next.t(VEHICLES_TYPES.TRUCK):
          // In case of truck without international or national routes, step credit is skipped
          if (routesSelected.indexOf(i18next.t(ROUTE_TYPES.INTERNATIONAL)) === -1 && routesSelected.indexOf(i18next.t(ROUTE_TYPES.NATIONAL)) === -1) {
            return true;
          }
          break;
        case i18next.t(VEHICLES_TYPES.CAR):
        case i18next.t(VEHICLES_TYPES.VAN):
          if (state.survey.vehiclesAmount === VEHICLES_AMOUNT.SIX_TEN || state.survey.vehiclesAmount === VEHICLES_AMOUNT.ELEVEN_MORE || state.survey.routeType.indexOf(i18next.t(ROUTE_TYPES.INTERNATIONAL)) !== -1) {
            return true;
          }
          break;
        case i18next.t(VEHICLES_TYPES.TAXI):
          if (state.survey.bill === i18next.t(OPTIONS.NO)) {
            return true;
          }
          break;
        case i18next.t(VEHICLES_TYPES.MIX):
          return true;
        default:
          return false;
      }
      break;
    default:

    return false;
  }
}

function isLastStep(state = initialState) {
  if (state.step === state.maxSteps) {
    return true;
  }
  
  return state.step === getNextStep(state);
}

export default rootReducer;
